<script setup lang="ts">
    // @ts-nocheck
    import { computed, onBeforeMount, ref, toRefs } from "vue";
    import KForm from "@/components/forms/Form/KForm.vue";
    import { getErrorMessage } from "@/api";
    import { flashMessage, openDialog } from "@/utils";
    import DialogAktivPatient from "@/tabs/Operation/DialogAktivPatient.vue";
    import DialogVardplatsbestallningInfo from "@/tabs/Vardplatsbokning/DialogVardplatsbestallningInfo.vue";
    import { Slutenvardsbesok, VardplatsStatus } from "@/tabs/Vardplatsbokning/types";
    import { useStore } from "@/store";

    const store = useStore();

    const props = defineProps<{
        slutenvardsbesokId: string;
    }>();

    const { slutenvardsbesokId } = toRefs(props);

    const formRef = ref();

    const slutenvardsbesok = computed(() =>
        store.getters["slutenvardsbesok/slutenvardsbesokById"]({ id: slutenvardsbesokId.value })
    );

    const onSubmit = async (formData: Partial<Slutenvardsbesok>) => {
        try {
            await store.dispatch("slutenvardsbesok/partialUpdateSlutenvardsbesok", {
                slutenvardsbesok: {
                    ...formData,
                    id: slutenvardsbesokId.value,
                    status: VardplatsStatus.STRUKEN,
                },
            });

            flashMessage("Vårdplats struken");

            emit("close");
        } catch (e) {
            openDialog("Det gick inte att stryka vårdplatsen. " + getErrorMessage(e), "error");
        }
    };

    const emit = defineEmits(["close"]);

    const onCancel = () => {
        emit("close");
    };

    onBeforeMount(async () => {
        await store.dispatch("slutenvardsbesok/getSlutenvardsbesokById", { id: slutenvardsbesokId.value });
    });
</script>

<template>
    <div class="stryk-vardplats">
        <DialogAktivPatient :patient="slutenvardsbesok.patient" />
        <DialogVardplatsbestallningInfo :vardplatsbestallning="slutenvardsbesok.vardplatsbestallning" />
        <KForm
            ref="formRef"
            id="stryk-vardplats-form"
            class="stryk-vardplats-form"
            submitSize="secondary"
            submitVariant="alert"
            submitContent="Stryk vårdplats"
            cancelSize="slim"
            cancelVariant="contour"
            cancelContent="Avbryt"
            @submit="onSubmit"
            @cancel="onCancel"
        >
            <template #default>
                <div class="form-content">
                    <KText type="textarea" name="strykningsorsak" label="Orsak" class="span-all" />
                    <FormulateInput type="checkbox" name="patient_utebliven" label="Patient utebliven" />
                    <FormulateInput type="checkbox" name="sen_avbokning" label="Sen avbokning" />
                </div>
            </template>
        </KForm>
    </div>
</template>
